// Refactored chat API using centralized apiClient
import { apiClient, extractPagination } from './client';
import { Message, Conversation } from '../models/Conversation';

export async function fetchInboxConversations(page = 1, archived = false): Promise<{ data: Conversation[]; pageCount: number; totalCount: number }>{
  const result = await apiClient.get<Conversation[]>('/chat/api/inbox', { page, archived: archived ? 'true' : undefined });
  if (!result.ok) {
    console.error('Error fetching inbox conversations:', result.error);
    return { data: [], pageCount: 0, totalCount: 0 };
  }
  const { pageCount, totalCount } = extractPagination(result.response);
  return { data: result.data || [], pageCount: pageCount ?? 0, totalCount: totalCount ?? 0 };
}

export async function fetchConversationByUserId(userId: number): Promise<any> {
  const result = await apiClient.get<any>('/chat/api/conversation', { userId });
  if (!result.ok) {
    console.error('Error fetching conversation by user ID:', result.error);
    return null;
  }
  if (result.data?.error === 'Cannot create a conversation with yourself') {
    return { error: result.data.error };
  }
  return result.data;
}

export async function fetchConversationById(conversationId: number): Promise<any> {
  const result = await apiClient.get<any>('/chat/api/conversation', { conversationId });
  if (!result.ok) {
    console.error('Error fetching conversation by ID:', result.error);
    return null;
  }
  return result.data;
}

export async function fetchMessagesByConversationId(conversationId: number, page: number): Promise<{ data: Message[]; pageCount: number }>{
  const result = await apiClient.get<Message[]>('/chat/api/messages', { conversationId, page });
  if (!result.ok) {
    console.error('Error fetching messages by conversation ID:', result.error);
    return { data: [], pageCount: 0 };
  }
  const { pageCount } = extractPagination(result.response);
  return { data: result.data || [], pageCount };
}

export async function sendMessage(recipientId: number, formData: FormData): Promise<any> {
  const result = await apiClient.postForm<any>(`/chat/send/message?json=1&id=${recipientId}`, formData);
  if (!result.ok) {
    console.error('Error sending message:', result.error);
    throw result.error;
  }
  return result.data;
}

export async function sendFlirt(recipientId: number): Promise<any> {
  const result = await apiClient.postJson<any>(`/chat/send/flirt?json=1&id=${recipientId}`);
  if (!result.ok) {
    console.error('Error sending flirt:', result.error);
    throw result.error;
  }
  return result.data;
}

export async function sendGift(recipientId: number, giftId: number): Promise<any> {
  const result = await apiClient.postJson<any>(`/chat/send/gift?json=1&id=${recipientId}&giftId=${giftId}`);
  if (!result.ok) {
    console.error('Error sending gift:', result.error);
    throw result.error;
  }
  return result.data;
}

export async function archiveConversation(conversationId: number): Promise<any> {
  const fd = new FormData();
  fd.append('conversationId', String(conversationId));
  const result = await apiClient.postForm<any>('/chat/api/archive', fd);
  if (!result.ok) {
    console.error('Error archiving conversation:', result.error);
    throw result.error;
  }
  return result.data;
}